/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By ${i?.author}`)
};

const es_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Por ${i?.author}`)
};

const de_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Von ${i?.author}`)
};

const nl_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Door ${i?.author}`)
};

const fr_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Par ${i?.author}`)
};

const it_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Di ${i?.author}`)
};

const pt_br2_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Por ${i?.author}`)
};

const pt_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Por ${i?.author}`)
};

const ja_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`著者: ${i?.author}`)
};

const zh_blog_by_author = /** @type {(inputs: { author: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`作者：${i?.author}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ author: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_by_author = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_by_author(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_by_author", locale)
	if (locale === "en") return en_blog_by_author(inputs)
	if (locale === "es") return es_blog_by_author(inputs)
	if (locale === "de") return de_blog_by_author(inputs)
	if (locale === "nl") return nl_blog_by_author(inputs)
	if (locale === "fr") return fr_blog_by_author(inputs)
	if (locale === "it") return it_blog_by_author(inputs)
	if (locale === "pt-BR") return pt_br2_blog_by_author(inputs)
	if (locale === "pt") return pt_blog_by_author(inputs)
	if (locale === "ja") return ja_blog_by_author(inputs)
	return zh_blog_by_author(inputs)
};